import { toPhoneNumberWithoutCharacters } from 'app/utils/PhoneNumberHelpers';

import { HCPModel, HCPRequestModel, HCPStatus, HCPUpdateModel } from '.';
import { getISODate, parseTimezone } from '../Lead';

export function getHCPStatusStr(status: HCPStatus | null | undefined): string {
  switch (status) {
    case HCPStatus.NONE:
      return 'None';
    case HCPStatus.GATHERING_INGO:
      return 'Gathering HCP Info';
    case HCPStatus.ONGOING_SUPPORT:
      return 'Ongoing Support';
    case HCPStatus.UNREACHABLE:
      return 'HCP Unreachable';
    case HCPStatus.UNABLE_TO_ENGAGE:
      return 'Unable to Engage';
    case HCPStatus.ASSISTED_WITH_OBTAINING_SAMPLE:
      return 'Assisted with Obtaining Sample';
    case HCPStatus.DIRECT_TO_SALES_REPRESENTATIVE_CONTACT:
      return 'Direct to Sales Representative Contact';
    case HCPStatus.INTERNATIONAL_INQUIRY_RESPONSE_PROVIDED:
      return 'International Inquiry Response Provided';
    case HCPStatus.PATIENT_SUPPORT_PROGRAM_INFORMATION_PROVIDED:
      return 'Patient Support Program Information Provided';
    case HCPStatus.PRODUCT_INFORMATION_PROVIDED:
      return 'Product Information Provided';
    case HCPStatus.REDIRECTED_TO_MEDICAL_INFORMATION:
      return 'Redirected to Medical Information';
    case HCPStatus.REIMBURSEMENT_INFORMATION_PROVIDED:
      return 'Reimbursement Information Provided';
    default:
      return 'None';
  }
}

export function parseHCP(lead: HCPModel): HCPUpdateModel {
  return {
    shortUuid: lead.uuid?.substring(0, 4) || '-',
    ...lead,
    hcp_status: lead?.hcp_status ? lead.hcp_status : HCPStatus.NONE,
    assigned_dt: getISODate(lead.assigned_dt),
    health_care_provider: {
      ...lead.health_care_provider,
      age: lead.health_care_provider.age ? lead.health_care_provider.age : null,
      phone: lead.health_care_provider?.phone ?? '',
      timezone: parseTimezone(lead.health_care_provider.timezone),
      zip_code: lead.health_care_provider?.zip_code?.code || '',
    },
    zip_code_state: lead.health_care_provider?.zip_code,
  } as unknown as HCPUpdateModel;
}

export function parseHCPUpdate(sur: HCPUpdateModel): HCPRequestModel {
  return {
    ...sur,
    hcp_status: sur.hcp_status,
    stage: sur.stage,
    health_care_provider: {
      ...sur.health_care_provider,
      timezone: sur.health_care_provider.timezone || undefined,
      phone: sur.health_care_provider?.phone ? toPhoneNumberWithoutCharacters(sur.health_care_provider?.phone) : '',
    },
  } as HCPRequestModel;
}
